var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFD014;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,40.7c0,13.3-9.1,24.1-20.4,24.1c-11.2,0-20.4-10.8-20.4-24.1V8.3H71V40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,64v1.4C55.4,74,62.4,81,71,81l0,0V89H55.4h-9.8H30.5V81l0,0c8.6,0,15.1-7,15.1-15.6V64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,16.4H87c0,0-0.9,24.4-16.9,31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,16.4H14c0,0,0.9,24.4,16.9,31.5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.2,19.2L46.4,27l-8.6,1.2c-0.7,0.1-1.1,1-0.5,1.6l6.2,6.1L42,44.5c-0.1,0.7,0.6,1.3,1.3,1l7.9-4l7.5,3.9 c0.7,0.4,1.5-0.2,1.3-1l-1.5-8.5l6.2-6.1c0.5-0.5,0.2-1.5-0.5-1.6L55.7,27l-3.8-7.8C51.5,18.6,50.5,18.6,50.2,19.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.2fe1842d36d2d46e3f6a59e42903ef06.svg";
export { ForwardRef as ReactComponent };